import PaginationComponent from './pagination'

const PaginationInstall = {
  install (Vue) {
    Vue.component('Pagination', PaginationComponent)
  }
}

export default PaginationInstall
